/* eslint-disable react/prop-types */
// Day.js
import React from 'react';
import moment from "moment";

const Day = ({ renderBodyItem, data, date }) => {
  const dayOfWeek = moment(date).format("ddd Do");

  return (
    <div style={{ border: '1px solid #ccc', padding: '10px', minHeight: '100px' }}>
      <div style={{ fontWeight: 600 }}>{dayOfWeek}</div>
      {renderBodyItem(data)}
      {/* <div>{day}</div>
      {data.map((event, index) => (
        <div
          key={index}
          style={{
            backgroundColor: event.color,
            padding: '5px',
            margin: '2px',
            borderRadius: '5px',
          }}
        >
          {event.title}
        </div>
      ))} */}
    </div>
  );
};

export default Day;